const textStyle = {
  fontFamily: "heading",
  fontWeight: "600",
  textAlign: "center",
};

const numberStyle = {
  fontFamily: "heading",
  fontSize: 5,
  fontWeight: "600",
  pt: 2,
  textAlign: "center",
};

const percentStyle = {
  fontFamily: "heading",
  fontSize: 3,
  fontWeight: "600",
  pt: 1,
  textAlign: "center",
};

const pieTextStyle = {
  fontFamily: "heading",
  fontSize: 4,
  fontWeight: "600",
  left: "50%",
  ml: "-50px",
  mt: "-20px",
  position: "absolute",
  textAlign: "center",
  top: "50%",
  width: "100px",
};

const legendStyle = {
  fontSize: 1,
};

export { textStyle, numberStyle, percentStyle, pieTextStyle, legendStyle };
